import { gql } from '@urql/core';
import { CollegeCardFragment } from 'generated/spin-graphql';
import Link from 'next/link';
import React from 'react';
import { CollegeCardContent } from './CollegeCardContent';

type Props = {
    className?: string;
    college: CollegeCardFragment;
};

gql`
    fragment CollegeCard on espin_college {
        slug
        scholarships
        ...CollegeCardContent
    }
`;

export const CollegeCard: React.FC<Props> = ({ className, college }) => {
    return (
        <Link href={`/colleges/${college.slug}`}>
            <a className={`college-card${className ? ` ${className}` : ''}`}>
                {college.scholarships && <div className="scholarships">Scholarships Available</div>}
                <CollegeCardContent college={college} />
            </a>
        </Link>
    );
};
